import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Comercial/CereriModels.cs ----------

export type RequestSource = 'Telefon' | 'Email' | 'Vizita'
export type RequestQualification = 'InAnaliza' | 'Acceptata' | 'Respinsa'
export type RequestRejectionReason =
  | 'CapacitateIndisponibila' | 'ProdusNeofertabil' | 'ClientBlocatCredit' | 'CantitateSubMinim' | 'TermenImposibil'

export interface ClientRequestLine {
  id: string | null
  articleId: string | null
  articleCode: string | null
  articleDescription: string | null
  freeTextDescription: string | null
  quantityThousands: number
}

export type SaveClientRequestLinePayload = Pick<ClientRequestLine, 'articleId' | 'freeTextDescription' | 'quantityThousands'>

export interface ClientRequestListItem {
  id: string
  number: string
  requestedDate: string
  clientId: string
  clientName: string
  source: RequestSource
  requestedByUserName: string
  qualification: RequestQualification
  rejectionReason: RequestRejectionReason | null
  responseTime: string | null
}

export interface ClientRequestDetail {
  id: string
  number: string
  requestedDate: string
  clientId: string
  clientName: string
  contactId: string | null
  contactName: string | null
  source: RequestSource
  requestedByUserId: string
  requestedByUserName: string
  notes: string | null
  qualification: RequestQualification
  rejectionReason: RequestRejectionReason | null
  qualificationNotes: string | null
  qualifiedAt: string | null
  qualifiedByUserName: string | null
  firstOfferAt: string | null
  responseTime: string | null
  lines: ClientRequestLine[]
}

export interface SaveClientRequestPayload {
  requestedDate: string
  clientId: string
  contactId: string | null
  source: RequestSource
  notes: string | null
  lines: SaveClientRequestLinePayload[]
}

export interface QualifyClientRequestPayload {
  qualification: RequestQualification
  rejectionReason: RequestRejectionReason | null
  notes: string | null
}

export const listClientRequests = () => api.get<ClientRequestListItem[]>('/comercial/cereri').then((r) => r.data)
export const getClientRequest = (id: string) => api.get<ClientRequestDetail>(`/comercial/cereri/${id}`).then((r) => r.data)
export const createClientRequest = (payload: SaveClientRequestPayload) =>
  api.post<{ id: string }>('/comercial/cereri', payload).then((r) => r.data)
export const updateClientRequest = (id: string, payload: SaveClientRequestPayload) =>
  api.put(`/comercial/cereri/${id}`, payload)
export const qualifyClientRequest = (id: string, payload: QualifyClientRequestPayload) =>
  api.post(`/comercial/cereri/${id}/calificare`, payload)

// ---------- FR-CER-004/006 — ATP (Available-to-Promise) ----------

export interface ClientRequestAtpLine {
  lineId: string
  articleId: string | null
  articleCode: string | null
  articleDescription: string | null
  quantityThousands: number
  availableQuantity: number
  coveredFromStock: number
  shortfallQuantity: number
  estimatedDeliveryDate: string | null
}
export interface ClientRequestAtpEstimate { clientRequestId: string; lines: ClientRequestAtpLine[]; summary: string }

export const getAtpEstimate = (id: string) => api.get<ClientRequestAtpEstimate>(`/comercial/cereri/${id}/estimare-atp`).then((r) => r.data)
